import React from 'react';
import { DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import { Label } from '@progress/kendo-react-labels';
import { SvgIcon } from '@progress/kendo-react-common';
import { chevronDownIcon } from '@progress/kendo-svg-icons';
import { useViewsContext, useGlobalizationContext, useTranslation } from '@cs-cms/state-management';

interface DropDownButtonItem {
  id: number;
  text: string;
  isPrivate: boolean;
}

export const ViewsDropdown: React.FC = () => {
  const { views, selectedView, setSelectedView } = useViewsContext();
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  const sortAlphabetically = (a: { name: string }, b: { name: string }) => a.name.localeCompare(b.name);

  const sortedViews = views?.length
    ? [
        ...views.filter(view => !view.isPrivate).sort(sortAlphabetically),
        ...views.filter(view => view.isPrivate).sort(sortAlphabetically)
      ]
    : [];

  const currentView = sortedViews.find(view => view.id === selectedView);

  const items: DropDownButtonItem[] = sortedViews.map(view => ({
    id: view.id,
    text: view.name,
    isPrivate: view.isPrivate
  }));

  const itemClicked = (event: DropDownButtonItemClickEvent) => {
    if (setSelectedView && event.item.id) {
      setSelectedView(event.item.id);
    }
  };

  const handleItemRender = (li: { item: DropDownButtonItem; itemIndex: number }) => {
    const isSystemView = !li.item.isPrivate;

    return (
      <Label key={li.item.id} style={{ fontWeight: isSystemView ? '600' : 'normal' }}>
        {li.item.text}
      </Label>
    );
  };

  return (
    <>
      {views && views.length > 1 && (
        <div>
          <Label>{translate('custom.common.view')}</Label>
          <DropDownButton
            endIcon={<SvgIcon icon={chevronDownIcon} />}
            text={currentView?.name}
            items={items}
            itemRender={handleItemRender}
            size={'medium'}
            themeColor={'base'}
            fillMode="solid"
            onItemClick={itemClicked}
            popupSettings={{
              popupClass: 'viewsDropdownPopup'
            }}
          />
        </div>
      )}
    </>
  );
};
